import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import ElementUI from 'element-ui';

import './assets/css/theme-green/index.css';       // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import "babel-polyfill";
import store from './store';

Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: 'small'
});
Vue.prototype.$axios = axios;
//Mock.bootstrap();
//使用钩子函数对路由进行权限跳转

axios.interceptors.request.use(
    config =>{
        if(window.$cookies.isKey('token')){
            //alert(window.$cookies.get('token'))
            config.headers.Authorization =  'Bearer ' + window.$cookies.get('token')
        }
        return config;
    },
    error =>{
        //对请求错误做什么
        return Promise.reject(error);
    });

axios.interceptors.response.use(
    response => {
        if (response.data) {
            //alert(response.data.msg);
            switch (response.data.code) {
                case 6:
                    store.dispatch('setCleanUp');
                    router.replace({path: 'login'})
            }
        }
        return response;
    },
    error =>{
        //对请求错误做什么
        if (error.response) {
            let errData = {};
            switch (error.response.status) {
                case 401:
                    store.dispatch('setCleanUp');
                    router.replace({path: 'login'});
                case 500:
                    errData.data = {
                        code: 2,
                        msg : '远程服务器500内部错误!'
                    };
                    break;
                case 503:
                    errData.data = {
                        code: 2,
                        msg : '远程服务器503内部错误!'
                    };
                    break;
                default:
                    errData.data = {
                        code: 2,
                        msg : error.response.statusText
                    };
                    break
            }
            return errData;
        }
    });

router.beforeEach((to, from, next) => {
    //如果用户已登录，可以继续访问路由，否则跳转到登陆
    const role = Vue.$cookies.get('token');
    if (!role && to.path !== '/login') {
        next('/login');
    } else {
        next();
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
